import { VueModule } from '@Foundation/utilities';
import NewsletterSubscriptionV2 from './code/Scripts/components/newsletter-subscription-v2';

export default VueModule({
  components: {
    NewsletterSubscriptionV2
  }
});
